var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.util = leica.pi.util || {};

/*
 * leica.pi.util.conference - object handles creating and managing slide conferences
 */
leica.pi.util.cConference = function (sysParams, document, $)
{
    var self = {};
    /**
     * DscInvitation table status values
     */
    self.errorCount = 0;
    /**
     * user is avaiable
     */
    self.DSCINVITATIONAVAILABLE = '0';
    /**
     * user is invited
     */
    self.DSCINVITATIONSTATINVITED = '1';
    /**
     * user has accepted
     */
    self.DSCINVITATIONSTATACCEPTED = '2';
    /**
     * user has declined, but message has not yet been read from server
     */
    self.DSCINVITATIONSTATDECLINING = '3';
    /**
     * leader has been informed of the decline
     */
    self.DSCINVITATIONSTATDECLINED = '4';
    /**
     * User clicked accept, but message gas not yet been read from server
     */
    self.DSCINVITATIONSTATACCEPTING = '5';

    /**
     * status values for the DscAvailability column in the Users table
     */
    /**
     * user is available
     */
    self.USERDSCAVAILABILITYAVAILABLE = '0';
    /**
     * user is busy
     */
    self.USERDSCAVAILABILITYBUSY = '1';
    /**
     * user is offline
     */
    self.USERDSCAVAILABILITYOFFLINE = '2';
    /**
     * Conferencing not allowed, e.g. role doesn't permit it, or running in eSM (which doesn't support conferencing)
     */
    self.USERDSCAVAILABILITYNOTALLOWED = '4';

    /*
     * set to true when the conference invitation poll is active, or we are in the
     * process of joining a conference. Also set to true if either the Conference Setup dialog
     * or the Conference Manager dialog is being displayed.
     * This prevents the conference invitation dialog from being displayed.
     */
    self.busyFlag = false;
    /**
     * Interval in milliseconds to check for conference invitations
     */
    self.conferenceInvitationResponsePollingIntervalMS = 10000;

    // public URLs that may differ in eSM vs Mustang/AIH
    // Can be overridden using a subsequently loaded JS file. e.g., conference.config.js
    self.viewerAssetsURL = "/viewer/viewerjs";
    self.viewerSettingsURL = "/viewer/vilsettings";
    self.saveEntitiesURL = "/dsapi/core/entities/save";
    self.getSetupDialogURL = "/conferencing/getconfsetupdialog";
    self.saveDscURL = "/conferencing/savedsc";
    self.setDscAvailabilityURL = "/conferencing/setavailable";
    self.getDscAvailabilityURL = "/conferencing/getavailable";
    self.getDscInviteURL = "/conferencing/inviteview";
    self.getDscInviteRequestURL = "/conferencing/getdscinvitation";
    self.getDscInviteResponseURL = "/conferencing/getdscinviteresponse";
    self.setDscInviteResponseURL = "/conferencing/setdscinviteresponse";

    /**
     * Get the logged in user auth token
     * @returns string
     */
    self.authToken = function ()
    {
        if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams))
        {
            return sysParams.AuthToken;
        }
        else if (typeof leica.pi.masterPayload !== 'undefined')
        {
            return leica.pi.masterPayload.userInfo.authIdentifier;
        }
        else
        {
            return "@token";
        }
    };
    /**
     * Get the logged in user full name, or login name if no full name
     * @returns string
     */
    self.fullName = function ()
    {
        if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams))
        {
            return (typeof (sysParams.FullName !== 'undefined') && (sysParams.FullName !== '')) ? sysParams.FullName : sysParams.LoginName;
        }
        else if (typeof leica.pi.masterPayload !== 'undefined')
        {
            return (typeof (leica.pi.masterPayload.userInfo.fullname !== 'undefined') && (leica.pi.masterPayload.userInfo.fullname !== '')) ? leica.pi.masterPayload.userInfo.fullname : leica.pi.masterPayload.userInfo.username;
        }
        else
        {
            return "";
        }
    };
    /**
     * Get the logged in user id
     * @returns string
     */
    self.userId = function ()
    {
        if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams))
        {
            return sysParams.UserId;
        }
        else if (typeof leica.pi.masterPayload !== 'undefined')
        {
            return leica.pi.masterPayload.userInfo.UserId;
        }
        else
        {
            return "";
        }
    };

    /**
     * Get the logged in user id
     * @returns string
     */
    self.setUserId = function (id)
    {
        if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams))
        {
            sysParams.UserId = id;
        }
        else if (typeof leica.pi.masterPayload !== 'undefined')
        {
            leica.pi.masterPayload.userInfo.UserId = id;
        }
    };

    /*
     * @returns bool
     * @param bool busyFlag - optional, specifies new busy state
     */
    self.isBusy = function (busyFlag)
    {
        if (undefined !== busyFlag)
        {
            self.busyFlag = busyFlag;
        }
        // return true if busyFlag is true if either the Conference Setup dialog or the Conference Manager dialog is being displayed
        return self.busyFlag === true;
    };

    /**
     * Is the current window href a peer review page
     * Not very elegant, but check the location.href for peerreview string
     */
    self.isPeerReviewPage = function ()
    {
        return (window.location.href.indexOf("/peerreview") > 0);
    };

    /**
     * Get the DST active primary key value
     * @returns 
     */
    self.dstCurrentRecordId = function ()
    {
        //peer review does not construct a proper DST object
        //it stores the study id in a hidden element on the page
        if (self.isPeerReviewPage())
        {
            return $('#studyId').val();
        }
        return $.getDstInstance().getActiveViewModel().activeCase().recordId;
    };

    self.dstEnhancedView = function ()
    {
        return (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams)) ? sysParams.DisplayHoverPopups : false;
    };

    /**
     * Given a conference id and name, get the URL parameters needed to create a conference setup dialog for either a study or case
     * @param DscId Conference Id
     * @param DscName Conference Name
     */
    self.getSetupManagerParams = function (DscId, DscName)
    {
        //default conference to use
        var schema = "dbo";
        var tableName = "Case";
        var recordId = self.dstCurrentRecordId();
        if (self.isPeerReviewPage())
        {
            schema = "PeerReview";
            tableName = "Study";
        }
        return encodeURI('DscName=' + DscName) +
                encodeURI('&DscId=' + DscId) +
                encodeURI('&Schema=' + schema) +
                encodeURI('&TableName=' + tableName) +
                encodeURI('&RecordId=' + recordId);
    };

    /**
     * Check Join Conference role permission. If current role doesn't have that permission
     * @returns {Boolean}
     */
    self.canDoConferencing = function ()
    {
        if (typeof leica.pi.masterPayload !== 'undefined')
        {
            // check Join Conference role permission. If current role doesn't have that permission
            // then there is no need to check for invitiations
            if (leica.pi.masterPayload.rolePermissions.HasPermission("Conferencing", leica.pi.masterPayload.roleCommandDefinitions.Join))
            {
                return true;
            }
        }
        else
        {
            //check for ESM style SystemParms
            //only HC has conferencing available
            if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams))
            {
                return !!sysParams.joinConferencing;
            }
        }
        //default to false
        return false;
    };

    /*
     * Ping server to see if there is a conference invitation pending
     * 
     * Returns false if token has expired
     */
    self.getConferenceInvitation = function (userId)
    {
        // if invite dialog is already open, nothing to do
        if (!self.isBusy())
        {
            if (self.canDoConferencing())
            {
                var params = (undefined != userId) ? {UserId: userId} : {};
                // check for a conference invitation
                self.isBusy(true);
                $.getJSON(self.getDscInviteRequestURL, params)
                        .done(function (data)
                        {
                            if (!$.isEmptyObject(data))
                            {
                                if (data.hasOwnProperty('LeaderName')
                                        && data.hasOwnProperty('Description')
                                        && data.hasOwnProperty('DscInvitationId')
                                        && data.hasOwnProperty('DscId'))
                                {
                                    leica.pi.util.conferenceInvite.presentConfInviteDialog(data.DscId, data.Description, data.DscInvitationId, data.LeaderName);
                                    return;
                                }
                                if (data.hasOwnProperty('Alert')) {
                                    console.log("Error getting conference invitation: " + data.Alert);
                                }
                            }
                            self.isBusy(false);
                        })
                        .fail(function (jqxhr, textStatus, error)
                        {
                            self.isBusy(false);
                            // don't report the first error, because an error can happen when changing pages.
                            // but if it happens more than one time in a row, then it is an error that should
                            // be reported
                            //if (self.errorCount++ > 0)
                            //{
                            console.log("Error getting conference invitation: " + textStatus + ' ' + error);
                            //}
                        });
            }
        }
        return true;
    };

    /*
     * decline a conference invitation. sets the DscInvitation Status to 3 (declining)
     */
    self.declineConference = function (dscInvitationId, declineReason)
    {
        // build json string to save the DscInvitation record
        var jsonStr = '{"Records":{"EntityBase":[{"Id" : "' + dscInvitationId + '","Status" : "' + self.DSCINVITATIONSTATDECLINING + '","DeclineReason" :"' + declineReason + '","@attributes" : {"xsi:type" : "DscInvitation"}}]}}';
        $.postJSON(self.saveEntitiesURL, jsonStr)
                .done(function ()
                {
                })
                .fail(function (jsonData)
                {
                    leica.pi.util.showMessage('Error updating conference database record:');
                })
                .always(function ()
                {
                    self.isBusy(false);
                });
    };

    /*
     * Join a conference invitation. 
     * Sets the DscInvitation Status to 5 (accepting),
     * and creates the conference popup window
     * @param dscId - the id of the dsc record
     * @param dscInvitationId - the id of the DscInvitation record (not the id of the user)
     */
    self.joinConference = function (dscId, dscInvitationId, joinMessage)
    {
        // accept the conference invitation by setting the DscInvitation record's Status = DSCUSERSTATACCEPTED
        var jsonStr = '{"Records":{"EntityBase":[{"Id" : "' + dscInvitationId + '","Status" : "' + self.DSCINVITATIONSTATACCEPTING + '","DeclineReason" :"' + joinMessage + '","@attributes" : {"xsi:type" : "DscInvitation"}}]}}';
        $.postJSON(self.saveEntitiesURL, jsonStr).done(function () {
            if ('undefined' === typeof $.fn.vil)
            {
                // need to force the viewer javascript and css to be loaded
                $.get(self.viewerAssetsURL).done(function (viewerJs) {
                    // TODO: use jQuery to dynamically load scripts (via getScripts) or use script loader to handle browser diffs
                    //$('head').append(viewerJs); // uncomment this (and comment out below method) for production

                    // Alternate approach to dynamic script loading that supports easier debugging of the source in browser dev tools
                    // Allows scripts to show up in chrome dev tools, where above approach does not (Use just for debugging in Chrome)
                    var viewerAssetNodes = $.parseHTML(viewerJs, true); // convert viewer asset string to HTML DOM nodes
                    $.each(viewerAssetNodes, function (index, el) {
                        if (el.nodename != '#text') {
                            if (el.nodeName == 'SCRIPT') {
                                var script = document.createElement('script');
                                script.src = el.src;
                                script.async = false; // *** not supported in IE < 10;
                                script.defer = false; // this is needed to prevent race conditions where script not loaded before accessed
                                document.head.appendChild(script); // this will make the source visible to browser debuggers                                
                            } else if (el.nodeName == 'LINK') {
                                $('head').append(el);
                                //$('body').append(el); // until spectrum fixed to not append CSS links to body, we need to append to body so jquery.dst.css comes after jquery-ui...custom.css
                            }
                        }
                    });

                    // viewer javascript is now loaded, finish joining the conference
                    self.finishJoinConference(dscId, dscInvitationId);
                });

            }
            else
            {
                // viewer javascript is already loaded, finish joining the conference
                self.finishJoinConference(dscId, dscInvitationId);
            }
        })
                .fail(function (jsonData)
                {
                    leica.pi.util.showMessage('Error updating conference database record:');
                });
    };
    self.finishJoinConference = function (dscId, dscInvitationId)
    {
        // save current VIL/DST settings if any
        self.saveVilState();

        // create the conference popup vil and join the conference
        self.createConferenceVIL(dscId, dscInvitationId);
    };
    /*
     * called when the user leaves a conference
     */
    self.leaveConference = function ()
    {
        // clear the busy flag
        self.isBusy(false);

        // restore the saved VIL (if any)
        if ($(document).data('savedVilSettings') !== '')
        {
            $(document).removeData('savedVilSettings');
        }
    };
    /*
     * we are going to create a VIL instance for the conference,
     * but since there can only be one VIL in existence at a time, we need 
     * to save the current VIL's (if any) settings and destroy that VIL.
     * That VIL will be recreated with the saved settings after the user
     * leaves the conference
     */
    self.saveVilState = function ()
    {
        // find the vilContainer div (if any)
        var vilDiv = $(document).find('#vilContainer');
        if (vilDiv.length > 0)
        {
            // VIL is now a singleton, all VIL functions must be made on the
            // object returned by $.getVilInstance()
            // 
            // need to make sure that the vilDiv we just found
            // is actually the one and only VIL instance
            var vilInstance = $.getVilInstance();
            if (vilDiv.is(vilInstance))
            {
                // save the uScope state in the VIL settings and close the uScope
                vilInstance.uScopeSaveAndClose();
                // save the VIL settings to be restored later
                $(document).data('savedVilSettings', vilInstance.getSettings()); // be careful - this used to clobber dstInfo with dstSettings -cb
                // save the DST state to the database
                ///??? Not needed for Peer Review, Needed in AIH ??            
                // vilInstance.saveDst();            
                // destroy the VIL ???
                // TODO: Do we need to save the DST state to the database here in 12.x?
            }
        }
    };

    // Note: This may be dead code -cb 8.5.2012
    self.getVilSettingSafe = function (settingName)
    {
        var result = "";
        var vilInstance = $.getVilInstance();
        if (undefined !== vilInstance)
        {
            vilInstance.syncSlideMemosFromDst(); // Make sure memos in VIL settings are synced up with any slide tray changes 
            var vilSettings = vilInstance.getConfiguration(); // don't use getSettings here until it is fixed -cb
            result = vilSettings[settingName];
        }
        return result;
    };

    self.getDSTInfoAsJson = function ()
    {
        var result = "";
        var vilInstance = $.getVilInstance();
        if (undefined !== vilInstance)
        {
            vilInstance.syncSlideMemosFromDst(); // Make sure memos in VIL settings are synced up with any slide tray changes 
            var vilSettings = vilInstance.getConfiguration();  // don't use getSettings here until it is fixed -cb 
            result = JSON.stringify(vilSettings.dstInfo);
        }
        return result;
    };

    // Note: This may be dead code -cb 8.5.2012
    self.saveDSTInfoToConference = function (dscId)
    {
        var vilInstance = $.getVilInstance();
        if (undefined !== vilInstance)
        {
            vilInstance.syncSlideMemosFromDst(); // Make sure memos in VIL settings are synced up with any slide tray changes 
            var vilSettings = vilInstance.getConfiguration(); // don't use getSettings here until it is fixed -cb

            $.post("/DSC_DstInfoSave.php", "DscId=" + dscId + "&DstInfo=" + encodeURIComponent(JSON.stringify(vilSettings.dstInfo)))
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        alert('Error saving slide tray info to the conference. Status = ' + textStatus + ' error = ' + errorThrown);
                    }
                    );

        }
    };

    // Note: This may be dead code -cb 8.5.2012
    self.getDSTInfoFromConference = function (dscId) {
        var vilInstance = $.getVilInstance();
        if (undefined !== vilInstance)
        {
            var vilSettings = vilInstance.getConfiguration(); // don't use getSettings here until it is fixed -cb     
            $.getJson("/DSC_DstInfoGet.php", "DscId=" + dscId)
                    .done(function (response) {
                        $.extend(true, vilSettings.dstInfo, response);
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        alert('Error retrieving slide tray info from the conference. Status = ' + textStatus + ' error = ' + errorThrown);
                    }
                    );
        }
    };


    /*
     * set or clear the conference busy flag. When busy flag is true,
     * conference invitation polling is suspended
     */
    self.setConferenceBusy = function (busyFlag)
    {
        if (window.__isAIH)
        {
            leica.pi.util.conference.isBusy(busyFlag);
        }
    };

    self.createConfManager = function (confName)
    {
        var managerDiv = $("<div>",
                {
                    "id": "confManager"
                });
        $('body').append(managerDiv);

        var confManager = $('#confManager');
        confManager.empty();
        confManager.append("<div id='confControlDiv' style='visibility:hidden;'>");
        confManager.append("<div class='dscHeader'><img class='dscHeaderImg' src=/images/participants.png >Participants" +
                "<input type='button' onclick='inviteParticipants()' style='visibility: hidden;' value='Invite' id='confInviteBtn' class='confBtn' title='Invite Additional Participants to the Conference' /></div>");
        confManager.append("<br>");
        confManager.append("<div id='prtListDiv'><ol id='prtListId'></ol></div>");
        confManager.append("<input type='hidden' name='ptName' id='ptName' value='' style='visibility:hidden' />");
        confManager.append("<input type='hidden' name='confName' id='confName' value='" + confName + "' style='visibility:hidden' />");

        confManager.append("<div id='confFollower' style='visibility:hidden;'><input type='button' onclick='requestLeadership()' value='Request Control' class='confBtn'/></div>");
        confManager.append("<div id='confGrabDiv' style='visibility:hidden;'><input type='button' onclick='grabLeadership()' value='Grab Control' class='confBtn'/></div>");
        confManager.append("<br></div>");

        confManager.append("<br><b>Chat</b><br>");
        confManager.append("<textarea rows='0' cols='0' readonly='readonly' onfocus='$(\"#outgoingChatBox\").focus();' id='confChatBox'></textarea><br>");
        confManager.append("<br><textarea rows='0' cols='0' id='outgoingChatBox' class='outgoingChatBox' onkeypress='if((event.which?event.which:event.keyCode)==13){sendUserMessage();event.preventDefault();return false;}'></textarea>");

        var dlg = confManager.dialog({
            autoOpen: false,
            title: 'Conference Manager',
            modal: false,
            resizable: true,
            position: [15, 100],
            open: function ()
            {
                self.setConferenceBusy(true);
                $('.confBtn').button();
                $('#outgoingChatBox').attr('placeholder', 'Type a message here and hit enter');
                $('#outgoingChatBox').focus();
            },
            close: function ()
            {
                self.setConferenceBusy(false);
                // wait until after we close the conference (which includes an AJAX call to change status back to available) to reload original page
                $.when($().conference('close')).always(function () {
                    // refresh the page when closing the manager (even if closing fails in some way)
                    //$('#confChatBox').val('');
                    // TODO: this approach (reload underlying page when pop-up conference ends) was added in AIH. It avoids a lot of state management issues, but should be re-evaluated at some point                       
                    location.reload(true);
                });
                //}
            }
        });
        $('#confManager').dialog('open');
    };

    self.createConferenceVIL = function (dscId, dscInvitationId)
    {
        // start a conf manager with 'dsc name'
        self.createConfManager(dscId);

        $('#ptName').val(dscInvitationId);

        // join the conference 
        var authToken = self.authToken();
        var fullName = self.fullName();
        var userId = self.userId();
        var DSCObject = {
            'dscId': dscId,
            'dscInvitationId': dscInvitationId,
            'authToken': authToken,
            'fullName': fullName,
            'userId': userId
        };
        $().conference('init');

        var json = JSON.parse('{"Records":{"EntityBase":[{"Id" : "' + dscInvitationId + '","Status" : "' + self.DSCINVITATIONSTATACCEPTING + '","@attributes" : {"xsi:type" : "DscInvitation"}}]}}');
        $.postJSON(self.saveEntitiesURL, json).fail(function () {
            leica.pi.util.showMessage('Error updating conference database record:');
        });

        //join the conference with the dsc connection information
        $().conference('join', DSCObject);
    };
    self.enableConfSetupButton = function ()
    {
        var enable = false;
        $('.dscUserCheckbox').each(function ()
        {
            if ($(this).attr('checked') !== undefined)
            {
                enable = true;
                return false;
            }
        });
        var button = $("#confSetupDialog").closest('.ui-dialog').find('.ui-button').first();
        // enable/disable first dialog button, and add/remove the jquery UI disabled class
        if (enable)
        {
            button.removeAttr("disabled").removeClass("ui-state-disabled");
        }
        else
        {
            button.attr("disabled", "disabled").addClass("ui-state-disabled");
        }
    };
    /**
     * Show the conferencing setup dialog where the leader initially creates the conference
     * @param DscId
     * @param DscName     
     */
    self.createConfSetupDialog = function (DscId, DscName)
    {
        if (undefined === DscId)
        {
            DscId = '';
        }
        if (undefined === DscName)
        {
            DscName = '';
        }

        // if DscId is empty, then we are creating a new conference, otherwise
        // we are inviting participants to an existing conference
        var createNewConference = '' === DscId;
        var ButtonText = createNewConference ? "Create" : "Invite";
        var dlgTitle = createNewConference ? "Create Conference" : "Invite Participants";

        $("<div>", {"id": "confSetupDialog"}).appendTo("body");

        var confSetupParams = self.getSetupManagerParams(DscId, DscName);
        // TODO:  handle error condition if list of users is not received -cb
        $('#confSetupDialog').load(self.getSetupDialogURL, confSetupParams).dialog(
                {
                    autoOpen: true,
                    title: dlgTitle,
                    modal: true,
                    resizable: false,
                    height: 340,
                    width: 320,
                    close: function ()
                    {
                        $(this).dialog("destroy").remove();
                    },
                    buttons:
                            [
                                {
                                    text: ButtonText,
                                    click: function ()
                                    {
                                        var participantCount = $('#DSCInviteForm').find('input:checked').length;
                                        if (participantCount < 1) {
                                            showMessageBox('Please select at least one participant.');
                                            return;
                                        }
                                        self.sendConferenceInvites().done(function (data) {
                                            if (createNewConference)
                                            {
                                                self.createNewConference(data.DscId, data.DscName);
                                            }
                                        });

                                        $(this).dialog("close");
                                    }
                                },
                                {
                                    text: 'Cancel',
                                    click: function () {
                                        $(this).dialog("close");
                                        $(this).empty();
                                    }
                                }
                            ]
                });
    };

    // Substitute for alert...
    function showMessageBox (text) {
        var $container = $('<div>' + text + '</div>');
        $container.dialog({
            modal: true,
            buttons: {
                'Ok': function () {
                    $container.dialog('close');
                    $container.remove();
                }
            }
        });
    }


    // Given a DSC (Digital Slide Conference) Id and Name, create a new conference and start listening for responses
    self.createNewConference = function (DscId, DscName) {
        var vil = $.getVilInstance();
        var vilDivId = vil.attr("id"); // we must have a VIL to ceate a conference
        var dst = vil.getDst();
        var vm = dst.getActiveViewModel();
        
        var dscSettings = {
            dscId: DscId,
            authToken: self.authToken(),
            fullName: self.fullName(),
            userId: self.userId(),
            vilDivId: vilDivId !== undefined ? vilDivId : 'vilContainer',
            dscName: DscName
        };
        if (vm) {      
            var imagesState = window.uScope.getImageState();
            // before starting the conference, close all pinned images 
            $.each(imagesState, function (i, val) {
                if (val.isPinned) {
                    vm.closeSlide(val.imagePath); // use slide tray to coordinate closing the images
                }
            });

            vm.settings.displayMultiSlide = false; // turn off multislide
            vm.refreshSettings(vm); // force refresh of settings dependent dst UI
        }
        // start a conf manager with 'dsc name'
        self.createConfManager(DscId);

        // create the conference
        $().conference('create', dscSettings);

        // start checking to see if any users declined
        setInterval(function ()
        {
            self.checkForInviteResponses(DscId);
        }, self.conferenceInvitationResponsePollingIntervalMS);
    };

    // This will create a conference if one does not already exist and return the DSC Id and Name in the response
    self.sendConferenceInvites = function () {
        // get the dstInfo and send to server to be saved with conference
        // Conference recipients can then read this info when joining the conference
        // Note that if leader deletes slides during conference, this may not be reflected in followers session
        var dstInfo = self.getDSTInfoAsJson();
        $('<input>').attr({type: 'hidden', id: 'dstInfoId', name: 'dstInfo'}).val(dstInfo).appendTo('#DSCInviteForm');

        return $.post(self.saveDscURL, $('#DSCInviteForm').serialize(), null, 'json')
                .fail(function (jqXHR, textStatus, errorThrown) {
                    leica.pi.util.showMessage('Error adding to DSC - status = ' + textStatus + ' error = ' + errorThrown);
                });
    };

    /**
     * Polling loop on the leader that continuously checks the DscInvitation table
     * for conference invitees who have responsed to the conference invite
     * @param dscId     
     */
    self.checkForInviteResponses = function (dscId)
    {
        $.getJSON(self.getDscInviteResponseURL, {"DscId": dscId}).done(function (userResponses) {
            // Check for null before passing to .each()
            if (!userResponses || !userResponses.length) {
                return;
            }
            //response is an array of invitation objects, each of which represents a user who has responded to the conference invite (accept or decline)
            $.each(userResponses, function (index, invite) {
                var msg = (invite.DeclineReason ? invite.DeclineReason : ''), // if reponse message undefined, set it to empty string
                        declining = (self.DSCINVITATIONSTATDECLINING == invite.Status),
                        userName = invite['UpToUsersByUserId.FullName'];
                // Adds response message to the leaders chat window; If the user declines, show the word 'Declined.', plus any message. 
                // If a user accepts, just show message. If no message, show 'Accepted.'  
                dscAddLineToChat(userName ? userName : "User " + invite.UserId, (declining ? "Declined. " + msg : (msg ? msg : 'Accepted.')));
                // Set the status column in the DscInvitation table from declining/accepting to declined/accepted; This prevents the response message from being fetched multiple times
                invite.Status = (declining ? self.DSCINVITATIONSTATDECLINED : self.DSCINVITATIONSTATACCEPTED);
                $.post(self.setDscInviteResponseURL, invite); //                    
            });
        });
    };


    /**
     * Update the conferencing availablility indication UI
     * TODO: Remove UI specific logic, which violates SOC. Instead, raise an event for clients to handle -cb
     * @param status 
     */
    self.setDscAvailIndicator = function (status)
    {
        $('.conferenceStatus i').removeClass('icon-circle');
        $('.DSCButtonGroup').removeAttr('checked');

        if (undefined === status)
        {
            status = self.USERDSCAVAILABILITYAVAILABLE;
        }

        switch (parseInt(status))
        {
            case parseInt(self.USERDSCAVAILABILITYAVAILABLE) :
                $('#dscAvailIndicator .DSCButtonGroup').prop("checked", true);
                $('#conferenceAvailable i').addClass('icon-circle');
                break;
            case parseInt(self.USERDSCAVAILABILITYBUSY) :
                $('#dscBusyIndicator .DSCButtonGroup').prop("checked", true);
                $('#conferenceBusy i').addClass('icon-circle');
                break;
            case parseInt(self.USERDSCAVAILABILITYOFFLINE) :
                $('#dscOfflineIndicator .DSCButtonGroup').prop("checked", true);
                $('#conferenceOffline i').addClass('icon-circle');
                break;
        }
    };

    /**
     * Get conferencing availability by user id
     * Used to set the little drop down conferencing dialog box status indicators
     * TODO: Figure out how to pass the parsed status in the returned promise
     * @param {type} userId
     * @param {type} disableCache
     * @returns {unresolved}
     */
    self.getDscAvailability = function (userId, disableCache)
    {
        if (typeof userId === 'undefined' || '' == userId) {
            userId = self.userId();
        }
        disableCache = disableCache || false;

        return $.post(self.getDscAvailabilityURL, {UserId: userId, DisableCache: disableCache})
                .done(function (response) {
                    var status = response.hasOwnProperty('Status') ? response.Status : response;
                    self.setDscAvailIndicator(status);
                })
                .fail(function (jqXHR, textStatus, errorThrown)
                {
                    if (jqXHR.status === 400)
                    {
                        leica.pi.util.showMessage("Error saving DSC availability:" + textStatus);
                    }
                });
    };

   
    /**
     * Set conferencing availability
     * status declared, uninitialized === undefined
     * @param {type} status
     * @param {type} userid
     * @returns {unresolved}
     */
    self.setDscAvailability = function (status, userid)
    {
        var data = {};
        if (typeof status === 'undefined' || null === status || '' === status) {
            status = self.USERDSCAVAILABILITYAVAILABLE;
        }

        //update the current user's conferencing availablity status client side
        if (typeof leica.pi.masterPayload !== 'undefined')
        {
            leica.pi.masterPayload.userInfo.DscAvailability = status;
        }

        if (window.__isAIH) {
            if (typeof userid === 'undefined') {
                userid = self.userId();
            }
            //data = {Records: {EntityBase: [{Id: userid, DscAvailability: status, "@attributes": {"xsi:type": "Users"}}]}};
             data = {Status: status};
        } else {
            data = {AJAX: true, SHC: true, Status: status};
        }


        // in pal mode, set the radio button here. setting it in the
        // sucess below is too slow and is confusing to the user.
        self.setDscAvailIndicator(status);
        $('#confBtn').trigger('hidePopover');
        return $.post(self.setDscAvailabilityURL, data)
                .fail(function (jqXHR, textStatus, errorThrown)
                {
                    if (jqXHR.status === 400)
                    {
                        leica.pi.util.showMessage("Error saving DSC availability:" + textStatus);
                    }
                });


    };

    return self;
};

var SystemParms = SystemParms || {};

// NetBeans navigator does not understand IIFEs. This is a workaround.
leica.pi.util.conference = new leica.pi.util.cConference(SystemParms, document, window.jQuery); // SystemParms is a global present only in the eSM environment